<div *nzModalTitle>Edit Definition: {{definitionName}}</div>

<app-definition-form
  [name]="definitionName"
  [categories]="categoryList"
  mode="edit"
  (definitionEdited)="onSubmitSuccess()"
  (definitionDeleted)="onSubmitSuccess()"
></app-definition-form>

